<template>
    <v-container v-if="company.search.data">
        <v-row text-center wrap>
            <v-col xs="12" sm="12" md="12" lg="6" xl="8">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Компания {{ company.search.data.name }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="updateCompanyPopup(company.search.data)"
                            color="primary"
                        >
                            Редактировать
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-row wrap text-left subheading>
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                ID:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="9" xl="9">
                                {{ company.search.data.id }}
                            </v-col>
                        </v-row>
                        <v-row wrap text-left subheading>
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                Дата добавления:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="9" xl="9">
                                {{ company.search.data.created }}
                            </v-col>
                        </v-row>
                        <v-row wrap text-left subheading>
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                Контактное лицо:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="9" xl="9">
                                {{ company.search.data.person }}
                            </v-col>
                        </v-row>
                        <v-row wrap text-left subheading>
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                Почта:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="9" xl="9">
                                {{ company.search.data.email }}
                            </v-col>
                        </v-row>
                        <v-row wrap text-left subheading>
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                Телефон:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="9" xl="9">
                                <div v-if="company.search.data.phone1">{{ phone1 }}<span v-if="company.search.data.phone_ext1">, доб. {{ company.search.data.phone_ext1 }}</span></div>
                                <div v-if="company.search.data.phone2">{{ phone2 }}<span v-if="company.search.data.phone_ext2">, доб. {{ company.search.data.phone_ext2 }}</span></div>
                                <div v-if="company.search.data.phone3">{{ phone3 }}<span v-if="company.search.data.phone_ext3">, доб. {{ company.search.data.phone_ext3 }}</span></div>
                            </v-col>
                        </v-row>
                        <v-row
                            v-if="!company.search.loading"
                            wrap text-left subheading
                        >
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                Администратор:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="9" xl="9">
                                {{ company.search.data.manager }}
                            </v-col>
                        </v-row>
                        <v-row
                            v-if="!company.search.loading"
                            wrap text-left subheading
                        >
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                Источник:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="9" xl="9">
                                {{ company.search.data.source }}
                            </v-col>
                        </v-row>
                        <v-row wrap text-left subheading>
                            <v-col xs="6" sm="4" md="4" lg="3" xl="3">
                                Статус:
                            </v-col>
                            <v-col xs="6" sm="8" md="8" lg="9" xl="9">
                                {{ company.search.data.status }}
                                <v-chip v-if="company.search.data.is_recruitment" small color="primary" class="ma-1">Подбор</v-chip>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="removeCompanyPopup(company.search.data)"
                            color="error"
                            text
                        >
                            Удалить компанию
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="6" xl="4">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Комментарий</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="updateCommentPopup(company.search.data)"
                            color="primary"
                        >
                            Редактировать
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div class="pre">{{ company.search.data.comment || 'Комментарий отсутствует' }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Комментарии и задачи</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="createTaskPopup"
                            color="success"
                        >
                            Добавить
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-data-table
                            :headers="task.search.headers"
                            :items="task.search.data"
                            :disable-sort="true"
                            :disable-pagination="true"
                            :loading="task.search.loading"
                            hide-default-footer
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.created }}</td>
                                    <td class="text-left">{{ item.manager.name }}</td>
                                    <td class="text-left">{{ item.message }}</td>
                                    <td class="text-left">{{ item.schedule }}</td>
                                    <td class="text-left">
                                        <div class="d-inline-flex align-center">
                                            <a
                                                v-if="item.can_complete"
                                                @click="taskComplete(item)"
                                                class="mr-2"
                                            >
                                                <v-icon
                                                    small
                                                >
                                                    mdi-flag
                                                </v-icon>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
            v-if="task.create.show"
            v-model="task.create.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Новый комментарий / Новая задача</v-card-title>
                <v-form
                    @submit.prevent="createTask"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-container>
                            <v-textarea
                                v-model="task.create.data.message"
                                :error-messages="task.create.errors.message"
                                label="Комментарий"
                            />
                            <v-select
                                v-model="task.create.data.status_id"
                                :error-messages="task.create.errors.status_id"
                                :items="status.search.data"
                                :cache-items="true"
                                item-text="name"
                                item-value="id"
                                label="Статус"
                            />
                            <v-row>
                                <v-col md="5" class="ma-0 pa-0">
                                    <v-menu
                                        v-model="task.create.menu.schedule_date"
                                        ref="menuScheduleDate"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="scheduleDate"
                                                @click:clear="task.create.data.schedule_date = null"
                                                :error-messages="task.create.errors.schedule_date"
                                                label="Дата начала"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                clearable
                                                v-on="on"
                                                class="col-md-2 mt-0 mb-0 ml-0 pl-0"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="task.create.data.schedule_date"
                                            @change="task.create.menu.schedule_date = false"
                                            locale="ru"
                                            first-day-of-week="1"
                                            color="primary"
                                            @input="task.create.errors.schedule_date = []"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col md="5" class="ma-0 pa-0">
                                    <v-menu
                                        v-model="task.create.menu.schedule_time"
                                        ref="menuScheduleTime"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="task.create.data.schedule_time"
                                                @click:clear="task.create.data.schedule_time = null"
                                                :error-messages="task.create.errors.schedule_time"
                                                label="Время начала"
                                                prepend-icon="mdi-clock-outline"
                                                readonly
                                                clearable
                                                v-on="on"
                                                class="col-md-2 mt-0 mb-0 ml-5 pl-5"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-model="task.create.data.schedule_time"
                                            format="24hr"
                                            locale="ru"
                                            color="primary"
                                            @click:minute="$refs.menuScheduleTime.save(task.create.data.schedule_time), task.create.errors.schedule_time = []"
                                        ></v-time-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                            @click="task.create.show = false"
                            :disabled="task.create.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="task.create.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="company.update.show"
            v-model="company.update.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Редактирование компании</v-card-title>
                <v-form
                    @submit.prevent="updateCompany"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-text-field
                            v-model="company.update.data.name"
                            :error-messages="company.update.errors.name"
                            name="name"
                            label="Название"
                            type="text">
                        </v-text-field>
                        <v-select
                            v-model="company.update.data.source_id"
                            :error-messages="company.update.errors.source_id"
                            :items="source.search.data"
                            :cache-items="true"
                            item-text="name"
                            item-value="id"
                            label="Источник"
                        ></v-select>
                        <v-text-field
                            v-model="company.update.data.person"
                            :error-messages="company.update.errors.person"
                            name="person"
                            label="Ф.И.О."
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="company.update.data.email"
                            :error-messages="company.update.errors.email"
                            name="email"
                            label="Почта"
                            type="text">
                        </v-text-field>
                        <v-row>
                            <v-col md="8" class="py-0">
                                <v-text-field
                                    v-model="company.update.data.phone1"
                                    v-mask="'+7 (###) ###-##-##'"
                                    :error-messages="company.update.errors.phone1"
                                    name="phone1"
                                    label="Телефон"
                                    type="text"
                                ></v-text-field>
                            </v-col>
                            <v-col md="4" class="py-0">
                                <v-text-field
                                    v-model="company.update.data.phone_ext1"
                                    :error-messages="company.update.errors.phone_ext1"
                                    name="phone_ext1"
                                    label="Добавочный"
                                    type="text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="8" class="py-0">
                                <v-text-field
                                    v-model="company.update.data.phone2"
                                    v-mask="'+7 (###) ###-##-##'"
                                    :error-messages="company.update.errors.phone2"
                                    name="phone2"
                                    label="Телефон"
                                    type="text"
                                ></v-text-field>
                            </v-col>
                            <v-col md="4" class="py-0">
                                <v-text-field
                                    v-model="company.update.data.phone_ext2"
                                    :error-messages="company.update.errors.phone_ext2"
                                    name="phone_ext2"
                                    label="Добавочный"
                                    type="text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="8" class="py-0">
                                <v-text-field
                                    v-model="company.update.data.phone3"
                                    v-mask="'+7 (###) ###-##-##'"
                                    :error-messages="company.update.errors.phone3"
                                    name="phone3"
                                    label="Телефон"
                                    type="text"
                                ></v-text-field>
                            </v-col>
                            <v-col md="4" class="py-0">
                                <v-text-field
                                    v-model="company.update.data.phone_ext3"
                                    :error-messages="company.update.errors.phone_ext3"
                                    name="phone_ext3"
                                    label="Добавочный"
                                    type="text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-select
                            v-model="company.update.data.manager_id"
                            :error-messages="company.update.errors.manager_id"
                            :items="manager.search.data"
                            :cache-items="true"
                            item-text="name"
                            item-value="id"
                            label="Администратор"
                        ></v-select>
                        <v-select
                            v-model="company.update.data.status_id"
                            :error-messages="company.update.errors.status_id"
                            :items="status.search.data"
                            :cache-items="true"
                            item-text="name"
                            item-value="id"
                            label="Статус"
                        ></v-select>
                        <v-checkbox
                            v-model="company.update.data.is_recruitment"
                            :error-messages="company.update.errors.is_recruitment"
                            label="Подбор персонала"
                            class="ma-0"
                        ></v-checkbox>
                        <v-checkbox
                            v-model="company.update.data.hidden"
                            label="Скрыть"
                            class="ma-0"
                        ></v-checkbox>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="company.update.show = false"
                            :disabled="company.update.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="company.update.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="company.comment.show"
            v-model="company.comment.show"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Редактирование комментария</v-card-title>
                <v-form
                    @submit.prevent="updateComment"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-textarea
                            v-model="company.comment.data.comment"
                            :error-messages="company.comment.errors.comment"
                            name="comment"
                            label="Комментария">
                        </v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="company.comment.show = false"
                            :disabled="company.comment.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="company.comment.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="company.remove.show"
            v-model="company.remove.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Удалить компанию {{ company.remove.data.name }}?</v-card-title>
                <v-card-text>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="company.remove.show = false"
                        :disabled="company.remove.progress"
                        color="red darken-1"
                        text
                    >
                        Отменить
                    </v-btn>
                    <v-btn
                        @click="removeCompany"
                        :loading="company.remove.progress"
                        color="green darken-1"
                        text
                    >
                        Удалить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "MarketingCompanyViewController",
    props: {
        id: Number,
    },
    data () {
        return {
            company: {
                comment: {
                    data: {
                        id: '',
                        comment: '',
                    },
                    errors: {
                        id: '',
                        comment: '',
                    },
                    progress: false,
                    show: false,
                },
                remove: {
                    data: {
                        id: '',
                        name: '',
                        remove: '',
                    },
                    progress: false,
                    show: false,
                },
                search: {
                    data: {
                        name: '',
                    },
                    loading: true,
                },
                update: {
                    data: {
                        id: '',
                        email: '',
                        hidden: false,
                        is_recruitment: false,
                        manager_id: 0,
                        name: '',
                        person: '',
                        phone1: '',
                        phone2: '',
                        phone3: '',
                        phone_ext1: '',
                        phone_ext2: '',
                        phone_ext3: '',
                        source_id: 0,
                    },
                    errors: {
                        id: [],
                        email: [],
                        is_recruitment: [],
                        manager_id: [],
                        name: [],
                        person: [],
                        phone1: [],
                        phone2: [],
                        phone3: [],
                        phone_ext1: [],
                        phone_ext2: [],
                        phone_ext3: [],
                        source_id: [],
                    },
                    progress: false,
                    show: false,
                },
            },
            manager: {
                search: {
                    data: [],
                    loading: true,
                },
            },
            source: {
                search: {
                    data: [],
                    loading: true,
                },
            },
            status: {
                search: {
                    data: [],
                    loading: true,
                },
            },
            task: {
                create: {
                    data: {
                        company_id: 0,
                        message: '',
                        schedule_date: null,
                        schedule_time: null,
                        status_id: 0,
                    },
                    errors: {
                        message: [],
                        schedule_date: [],
                        schedule_time: [],
                        status_id: [],
                    },
                    menu: {
                        schedule_date: false,
                        schedule_time: false,
                    },
                    progress: false,
                    show: false,
                },
                search: {
                    data: [],
                    headers: [
                        {
                            text: 'Дата',
                            value: 'created',
                        },
                        {
                            text: 'Администратор',
                            value: 'manager.name',
                        },
                        {
                            text: 'Комментарий',
                            value: 'message',
                        },
                        {
                            text: 'Время выполнения',
                            value: 'schedule',
                        },
                        {
                            text: 'Действия',
                            value: 'id',
                        },
                    ],
                    loading: true,
                },
            },
        }
    },
    computed: {
        accessTillDate () {
            return this.formatDate(this.task.create.data.till_date)
        },
        phone1 () {
            const phone = this.company.search.data.phone1
            return phone[0] + phone[1] + ' (' + phone[2] + phone[3] + phone[4] + ') ' + phone[5] + phone[6] + phone[7] + '-' + phone[8] + phone[9] + '-' + phone[10] + phone[11]
        },
        phone2 () {
            const phone = this.company.search.data.phone2
            return phone[0] + phone[1] + ' (' + phone[2] + phone[3] + phone[4] + ') ' + phone[5] + phone[6] + phone[7] + '-' + phone[8] + phone[9] + '-' + phone[10] + phone[11]
        },
        phone3 () {
            const phone = this.company.search.data.phone3
            return phone[0] + phone[1] + ' (' + phone[2] + phone[3] + phone[4] + ') ' + phone[5] + phone[6] + phone[7] + '-' + phone[8] + phone[9] + '-' + phone[10] + phone[11]
        },
        scheduleDate () {
            return this.formatDate(this.task.create.data.schedule_date)
        },
    },
    created () {
        this.searchCompany()
        this.searchManagers()
        this.searchSources()
        this.searchStatuses()
        this.searchTasks()
    },
    methods: {
        createTask () {
            this.task.create.progress = true

            this.$axios.post('/manager/marketing/task/create', this.task.create.data)
                .then((res) => {
                    if (res.data.success) {
                        this.task.create.show = false
                        this.task.create.data.message = ''
                        this.task.create.data.schedule_date = null
                        this.task.create.data.schedule_time = null

                        this.company.search.data.status_id = this.task.create.data.status_id
                        this.company.search.data.status = this.status.search.data.filter(s => s.id === this.company.search.data.status_id)[0].name

                        this.searchTasks()
                    } else {
                        this.task.create.errors.message = res.data.errors.message || []
                        this.task.create.errors.schedule_date = res.data.errors.schedule_date || []
                        this.task.create.errors.schedule_time = res.data.errors.schedule_time || []
                    }

                    this.task.create.progress = false
                })
                .catch(() => {
                    this.task.create.progress = false
                })
        },

        createTaskPopup () {
            this.task.create.data.company_id = this.company.search.data.id
            this.task.create.data.status_id = this.company.search.data.status_id
            this.task.create.show = true
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}.${month}.${year}`
        },

        removeCompany () {
            this.company.remove.progress = true

            this.$axios.post('/manager/marketing/company/remove', this.company.remove.data)
                .then((res) => {
                    if (res.data.success) {
                        this.company.remove.show = false
                        this.company.remove.data.id = 0
                        this.company.remove.data.name = ''

                        this.$router.push('/marketing/company')
                    }

                    this.company.remove.progress = false
                })
                .catch(() => {
                    this.company.remove.progress = false
                })
        },

        removeCompanyPopup (company) {
            this.company.remove.data.id = company.id
            this.company.remove.data.name = company.name
            this.company.remove.show = true
        },

        searchCompany () {
            this.company.search.loading = true

            this.$axios.post('/manager/marketing/company/search', {id: this.id})
                .then(res => {
                    if (res.data.success) {
                        this.company.search.data = res.data.data
                    }

                    this.company.search.loading = false
                })
                .catch(() => {
                    this.company.search.loading = false
                })
        },

        searchManagers () {
            this.manager.search.loading = true

            this.$axios.post('/manager/user/search')
                .then(res => {
                    if (res.data.success) {
                        this.manager.search.data = res.data.data.filter(m => {return m.manager})
                    }

                    this.manager.search.loading = false
                })
                .catch(() => {
                    this.manager.search.loading = false
                })
        },

        searchSources () {
            this.source.search.loading = true

            this.$axios.post('/manager/marketing/source/search')
                .then(res => {
                    if (res.data.success) {
                        this.source.search.data = res.data.data
                    }

                    this.source.search.loading = false
                })
                .catch(() => {
                    this.source.search.loading = false
                })
        },

        searchStatuses () {
            this.status.search.loading = true

            this.$axios.post('/manager/marketing/status/search')
                .then(res => {
                    if (res.data.success) {
                        this.status.search.data = res.data.data
                    }

                    this.status.search.loading = false
                })
                .catch(() => {
                    this.status.search.loading = false
                })
        },

        searchTasks () {
            this.task.search.loading = true

            this.$axios.post('/manager/marketing/task/search', {company_id: this.id})
                .then(res => {
                    if (res.data.success) {
                        this.task.search.data = res.data.data
                    }

                    this.task.search.loading = false
                })
                .catch(() => {
                    this.task.search.loading = false
                })
        },

        taskComplete (task) {
            this.$axios.post('/manager/marketing/task/complete', {id: task.id})
                .then(() => {
                    this.searchTasks()
                })
                .catch(() => {
                    this.searchTasks()
                })
        },

        updateComment () {
            this.company.comment.progress = true

            this.company.comment.errors.id = []
            this.company.comment.errors.comment = []

            this.$axios.post('/manager/marketing/company/comment', this.company.comment.data)
                .then((res) => {
                    if (res.data.success) {
                        this.company.comment.show = false
                        this.company.comment.data.id = 0
                        this.company.comment.data.comment = ''

                        this.searchCompany()
                    } else {
                        this.company.comment.errors.id = res.data.errors.id || []
                        this.company.comment.errors.comment = res.data.errors.comment || []
                    }

                    this.company.comment.progress = false
                })
                .catch(() => {
                    this.company.comment.progress = false
                })
        },

        updateCommentPopup (company) {
            this.company.comment.data.id = company.id
            this.company.comment.data.comment = company.comment
            this.company.comment.show = true
        },

        updateCompany () {
            this.company.update.progress = true

            this.$axios.post('/manager/marketing/company/update', this.company.update.data)
                .then((res) => {
                    if (res.data.success) {
                        this.company.update.show = false
                        this.company.update.data.id = 0
                        this.company.update.data.email = ''
                        this.company.update.data.hidden = false
                        this.company.update.data.is_recruitment = false
                        this.company.update.data.manager_id = 0
                        this.company.update.data.name = ''
                        this.company.update.data.person = ''
                        this.company.update.data.phone1 = ''
                        this.company.update.data.phone2 = ''
                        this.company.update.data.phone3 = ''
                        this.company.update.data.phone_ext1 = ''
                        this.company.update.data.phone_ext2 = ''
                        this.company.update.data.phone_ext3 = ''
                        this.company.update.data.source_id = 0
                        this.company.update.data.status_id = 0

                        this.searchCompany()
                    } else {
                        this.company.update.errors.id = res.data.errors.id || []
                        this.company.update.errors.email = res.data.errors.email || []
                        this.company.update.errors.is_recruitment = res.data.errors.is_recruitment || []
                        this.company.update.errors.manager_id = res.data.errors.manager_id || []
                        this.company.update.errors.name = res.data.errors.name || []
                        this.company.update.errors.person = res.data.errors.person || []
                        this.company.update.errors.phone1 = res.data.errors.phone1 || []
                        this.company.update.errors.phone2 = res.data.errors.phone2 || []
                        this.company.update.errors.phone3 = res.data.errors.phone3 || []
                        this.company.update.errors.phone_ext1 = res.data.errors.phone_ext1 || []
                        this.company.update.errors.phone_ext2 = res.data.errors.phone_ext2 || []
                        this.company.update.errors.phone_ext3 = res.data.errors.phone_ext3 || []
                        this.company.update.errors.source_id = res.data.errors.source_id || []
                        this.company.update.errors.status_id = res.data.errors.status_id || []
                    }

                    this.company.update.progress = false
                })
                .catch(() => {
                    this.company.update.progress = false
                })
        },

        updateCompanyPopup (company) {
            this.company.update.data.id = company.id
            this.company.update.data.email = company.email
            this.company.update.data.hidden = company.hidden
            this.company.update.data.is_recruitment = !!company.is_recruitment
            this.company.update.data.manager_id = company.manager_id
            this.company.update.data.name = company.name
            this.company.update.data.person = company.person
            this.company.update.data.phone1 = company.phone1 || ''
            this.company.update.data.phone2 = company.phone2 || ''
            this.company.update.data.phone3 = company.phone3 || ''
            this.company.update.data.phone_ext1 = company.phone_ext1 || ''
            this.company.update.data.phone_ext2 = company.phone_ext2 || ''
            this.company.update.data.phone_ext3 = company.phone_ext3 || ''
            this.company.update.data.source_id = company.source_id
            this.company.update.data.status_id = company.status_id
            this.company.update.show = true
        },
    },
}
</script>

<style>
.pre {
    white-space: pre-line;
}
</style>
